import { alpha } from "@mui/material/styles";
import { red } from "../colors";

export const MuiSwitch = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: "red" },
          style: {
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: red[100],
              "&:hover": {
                backgroundColor: alpha(red[100], 0),
              },
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: red[100],
            },
          },
        },
      ],
    },
  },
};
